import { useState, useEffect } from "react";
import { apiClient } from "../App";

const TONE_CLASSES = {
  amber: "bg-amber-100 text-amber-900 border-amber-400",
  blue: "bg-sky-100 text-sky-900 border-sky-400",
  green: "bg-emerald-100 text-emerald-900 border-emerald-500",
};

/**
 * OCI V2.6 Phase A — Environment badge.
 * Pulls /api/platform/environment and renders an always-visible pill.
 * Cannot be missed: bold border, uppercase, distinctive colour.
 */
export function EnvironmentBadge({ size = "sm" }) {
  const [env, setEnv] = useState(null);

  useEffect(() => {
    apiClient.get("/platform/environment")
      .then((r) => setEnv(r.data))
      .catch(() => setEnv({ label: "UNKNOWN", tone: "amber" }));
  }, []);

  if (!env) return null;
  const tone = TONE_CLASSES[env.tone] || TONE_CLASSES.amber;
  const padding = size === "lg" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-[11px]";

  return (
    <span
      data-testid="environment-badge"
      data-env={env.environment}
      className={`inline-flex items-center gap-1 font-bold uppercase tracking-wide
                   border-2 rounded-md ${padding} ${tone}`}
      title={`Environment: ${env.label}`}
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full"
            style={{ background: env.hex }}></span>
      {env.label}
    </span>
  );
}
